import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ResetPasswordComponent } from '../../reset-password/reset-password.component';
@NgModule({
  declarations: [ResetPasswordComponent],   // ✅ declare the component
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,  
  ],
  exports: [ResetPasswordComponent]         // ✅ export if used elsewhere
})
export class ResetPasswordModule { }